import { useEffect, useState } from 'react';

const links = [
  { id: 'home', label: '首页', icon: 'ri-home-5-line' },
  { id: 'hot', label: '今日热榜', icon: 'ri-fire-line' },
  { id: 'feed', label: '最新投稿', icon: 'ri-focus-3-line' },
  { id: 'guide', label: '玩瓜指南', icon: 'ri-compass-3-line' },
  { id: 'faq', label: '常见问题', icon: 'ri-questionnaire-line' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" onClick={() => go('home')} className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-disc-fill text-xl"></i>
          </span>
          <span className="font-heading text-2xl tracking-wide text-foreground-950">53吃瓜</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => { e.preventDefault(); go(l.id); }}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              <i className={`${l.icon}`}></i>
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#post"
            onClick={(e) => { e.preventDefault(); go('post'); }}
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-edit-2-line text-base"></i>
            我要投稿
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-100 text-foreground-900 md:hidden"
            aria-label="菜单"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => { e.preventDefault(); go(l.id); }}
                className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                <i className={`${l.icon} text-primary-600`}></i>
                {l.label}
              </a>
            ))}
            <a
              href="#post"
              onClick={(e) => { e.preventDefault(); go('post'); }}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-background-50"
            >
              <i className="ri-edit-2-line"></i>
              我要投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}